export default __webpack_public_path__ + "static/media/test.d43eba5b.png";